import { ThunkType } from "../../../../../core/store/reducers";
import createCommissionDetailApi from "../../api/commissionDetails/createCommissionDetail";
import updateCommissionDetailApi from "../../api/commissionDetails/updateCommissionDetail";
import { setFetchStateAttribute } from "../../commissionsDataReducer";
import { CommissionDetail } from "../../types";

export const upsertCommissionDetail = (detail: CommissionDetail): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return;
	}

	dispatch(setFetchStateAttribute({ type: "started" }));

	const { userId } = store.data.auth.current.user;
	const result = detail.commDetId
		? await dispatch(updateCommissionDetailApi(userId, detail))
		: await dispatch(createCommissionDetailApi(userId, detail));

	if (result && result.resCode === "OK") {
		dispatch(setFetchStateAttribute({ type: "successful", result: result.resDesc }));
		return result.resDesc;
	} else {
		dispatch(setFetchStateAttribute({ type: "error", errorCode: result?.resCode }));
	}
};
